import styled from "styled-components";
import { Tab as T, Tabs as Ts } from "@mui/material";
import { COLORS } from "screens/perfilAutonomo/utils";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

export const Row = styled.div<{ template?: string }>`
  display: grid;
  grid-template-columns: ${({ template }) => template ?? "1fr 1fr"};
  width: 100%;
  gap: 20px;
`;

export const Flex = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
`;

export const Tabs = styled(Ts)`
  width: 100%;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);
`;

export const Tab = styled(T)<{ selected: boolean }>`
  color: ${({ selected }) =>
    selected ? COLORS.primary500 : COLORS.gray500} !important;
  text-transform: none !important;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  .label {
    font-size: 16px;
    font-weight: 500;
    color: ${COLORS.gray500};
  }
`;
